<div
  class="chip medium-type font-body-2 flex--inline flex--middle align-center ps-xsmall-x rounded-medium"
  [ngClass]="{
    'nordic-blue-900-text nordic-blue-25-bg': theme === ChipTheme.DEFAULT,
    'nordic-blue-900-bg white-text': theme === ChipTheme.ACTIVE,
    'birch-50-bg birch-600-text': theme === ChipTheme.SUSTAINABILITY
  }"
>
  <ng-content></ng-content>
</div>
